export default class Accordion {
  constructor(toggler) {
    this.toggler = toggler;
    this.id = this.toggler.dataset.accordionToggler;

    if (this.id) {
      switch (this.id) {
        case 'next':
          this.content = this.toggler.nextElementSibling;
          break;
        default:
          this.content = document.querySelector(`[data-accordion-content="${this.id}"]`);
          break;
      }
    }

    if (!this.id || !this.content) {
      return console.error('no accordion content detected');
    }
    this.animate = this.content.dataset.accordionAnimate || false;

    this.isOpen = false;
    this.close();
    this.bind();
  }

  bind() {
    this.toggle = this.toggle.bind(this);
    this.toggler.addEventListener('click', this.toggle);
  }

  destroy() {
    this.toggler.removeEventListener('click', this.toggle);
  }

  toggle(e) {
    e && e.preventDefault();
    this[this.isOpen ? 'close' : 'open']();
  }

  open() {
    if (!this.animate) {
      console.info('foo');
      this.content.style.display = 'block';
    }
    this.content.classList.add('is-visible');
    this.toggler.classList.add('is-open');
    this.isOpen = true;
  }

  close() {
    if (!this.animate) {
      console.info('bar');
      this.content.style.display = 'none';
    }
    this.content.classList.remove('is-visible');
    this.toggler.classList.remove('is-open');
    this.isOpen = false;
  }
}
